import Typography from "@mui/material/Typography";

export const JobBlurbCompanyDescription = () => (
  <>
    <Typography paragraph>
      Everyone deserves a career they&apos;re passionate about. At Dreambound, we help Americans find
      their purpose and everything they need in order to get there.
    </Typography>
    <Typography paragraph>
      Most people avoid career changes because it feels impossible: the risk, the uncertainty, the
      unclear starting points. We&apos;re changing that. Through partnerships with hundreds of schools
      nationwide, we&apos;ve helped millions of Americans start new futures in healthcare, tech,
      skilled trades, and business.
    </Typography>
    <Typography paragraph>
      We&apos;re backed by{" "}
      <a href="https://www.usv.com/">Union Square Ventures</a>,{" "}
      <a href="https://www.collaborativefund.com/">Collaborative Fund</a>,{" "}
      <a href="https://8vc.com">8VC</a>,{" "}
      <a href="https://www.moxxie.vc/">Moxxie</a>, and the founders of Rippling, Thumbtack, and
      Clipboard Health, among others.
    </Typography>
  </>
);

export const JobBlurbRegulatory = () => (
  <>
    <Typography variant="new_h3">A diverse and inclusive workplace</Typography>
    <Typography paragraph variant="disclaimer">
      Dreambound is committed to an inclusive and diverse workplace. All aspects of employment
      including the decision to hire, promote, discipline, or discharge, will be based on merit,
      competence, performance, and business needs.
    </Typography>
    <Typography paragraph variant="disclaimer">
      We do not discriminate on the basis of race, color, religion, marital status, age, national
      origin, ancestry, physical or mental disability, medical condition, pregnancy, genetic
      information, gender, sexual orientation, gender identity or expression, veteran status, or any
      other status protected under federal, state, or local law &mdash; including the San Francisco
      Fair Chance Ordinance, under which we will consider all qualified applicants with arrest and
      conviction records.
    </Typography>
  </>
);
